// src/config.js

// Get environment from env var or default to DEV for local development
const currentEnv = process.env.REACT_APP_ENV || "DEV";

// Environment-specific API URL defaults
const environmentDefaults = {
  // Default API port matches backend dev (uvicorn --port 9475); see client/.env.development
  DEV: "http://127.0.0.1:9475",
  UAT: "http://localhost:2001/LapturaApi", // IIS or staging server
  PROD: "https://api.laptura.app", // Production API
};

// Get API URL: REACT_APP_API_URL overrides everything, otherwise use environment default
const getApiUrl = () => {
  // If REACT_APP_API_URL is set, use it (overrides environment defaults)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Otherwise use environment-specific default
  return environmentDefaults[currentEnv] || environmentDefaults.DEV;
};

// Removed unused environments object

const config = {
  apiUrl: getApiUrl(), // Use the function to get the correct URL
  environment: currentEnv,
};

// FastAPI Endpoints
export const ENDPOINTS = {
  // AIM Analysis endpoints
  uploadAim: "/aim/upload-aim",
  uploadJob: (id) => `/jobs/${id}`,
  aimSessions: "/aim/sessions",
  sessions: "/aim/sessions",
  sessionData: (id) => `/aim/session/${id}/data`,
  sessionRawData: (id) => `/aim/session/${id}/raw-data`,
  deleteSession: (id) => `/aim/session/${id}`,
  reprocessSession: (id) => `/aim/session/${id}/reprocess`,
  sessionTrackSvg: (id) => `/aim/session/${id}/track-svg`,
  sessionCornerSvg: (sessionId, cornerNumber) => `/aim/session/${sessionId}/corner/${cornerNumber}/svg`,

  // Public track endpoints (for demo/mock data)
  publicTrackSvg: (trackName) => `/aim/track-svg/${trackName}`,
  
  // Auth endpoints
  login: "/auth/login",
  register: "/auth/register",
  accessCode: "/auth/access-code",
  legal: "/auth/legal",
  acceptLegal: "/auth/legal/accept",
  me: "/auth/me",
  preferences: "/auth/preferences",
  
  // AI Coach endpoints
  chat: "/coach/chat",
  chatStream: "/coach/chat/stream",
  chatHistory: "/coach/chat/history",
  coachFeedback: (runId) => `/coach/runs/${runId}/feedback`,
  coachCapabilities: "/coach/capabilities",
  quickTips: "/coach/quick-tips",
  
  // Session Notes endpoints
  sessionNotes: (id) => `/aim/session/${id}/notes`,

  // IMSA Race Analysis endpoints
  imsaSessions: "/imsa/sessions",
  imsaImportSession: "/imsa/sessions/import",
  imsaSession: (id) => `/imsa/sessions/${id}`,
  imsaSessionCar: (sessionId, carNumber) => `/imsa/sessions/${sessionId}/car/${carNumber}`,
  imsaCompareCars: (sessionId) => `/imsa/sessions/${sessionId}/compare`,
  imsaRaceTrace: (sessionId) => `/imsa/sessions/${sessionId}/race-trace`,
  imsaRacePace: (sessionId) => `/imsa/sessions/${sessionId}/race-pace`,
  imsaFlagsWeather: (sessionId) => `/imsa/sessions/${sessionId}/flags-weather`,
  imsaRematchTelemetry: (sessionId) => `/imsa/sessions/${sessionId}/rematch-telemetry`,

  // Phase 2 IMSA linkage endpoints
  rematchImsa: (id) => `/aim/session/${id}/rematch-imsa`,
  imsaLink: (id) => `/aim/session/${id}/imsa-link`,
  raceContext: (id) => `/aim/session/${id}/race-context`,
};

export default config;
